/**
 * One node of the tree `TreeFieldComponent` renders.
 *
 * A plain, serializable shape with no parent links — unlike `TreeViewNode`, which holds a
 * `parent` reference and therefore needs a custom `toJSON` to break the cycle. Children
 * point downwards only; the field derives everything it needs (leaves, selected
 * ancestors) by walking down.
 */
export interface TreeFieldNode {
    /** identifies the node; a leaf's value is what lands in the field's value */
    value: string;
    /** what the user reads */
    label: string;
    /** shown but not choosable; on a branch it blocks the branch's own leaves too */
    disabled?: boolean;
    /** absent or empty makes this a leaf, and only leaves are selectable */
    children?: TreeFieldNode[];
}

/**
 * @param nodes the nodes to walk
 * @returns every leaf beneath them, depth first
 */
export function collectTreeFieldLeaves(nodes: readonly TreeFieldNode[]): TreeFieldNode[] {
    return nodes.flatMap((node) => (node.children?.length ? collectTreeFieldLeaves(node.children) : [node]));
}
